/* region config map */
const regionMap = new Map()

const context = require.context('./lib', true, /\.json$/)
context.keys().forEach((x) => {
  const config = context(x)
  regionMap.set(config.COUNTRY, config)
})

export default regionMap
